import AspApi, { OpenAiApi } from '../../../api/ApiConfig';

export const createTemplateStep1 = async (payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/whatsapp/whatsapp_templates`,
    payLoad,
  );
  return res;
};

export const getTemplate = async (id, payLoad) => {
  const res = await AspApi.get(
    `/api/v1/svc/whatsapp/whatsapp_templates/${id}?brand_id=${payLoad?.brandId}`,
  );

  return res;
};

export const templateUpdate = async (id, payLoad) => {
  const res = await AspApi.patch(
    `/api/v1/svc/whatsapp/whatsapp_templates/${id}`,
    payLoad,
  );
  return res;
};

export const templateApprovedEdit = async (id, payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/whatsapp/whatsapp_templates/${id}/initiate_edit`,
    payLoad,
  );
  return res;
};

export const duplicateTemplate = async (id, payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/whatsapp/whatsapp_templates/${id}/duplicate_template`,
    payLoad,
  );
  return res;
};

export const whatsappBusinessNumbers = async (brandId) => {
  const res = await AspApi.get(
    `/api/v1/svc/whatsapp/whatsapp_numbers?brand_id=${brandId}`,
  );
  return res;
};

export const templateLists = async (brandId, query) => {
  let qpm = [];

  if (brandId) qpm.push(`brand_id=${brandId}`);
  if (query?.page) qpm.push(`page=${query?.page}`);
  if (query?.limit) qpm.push(`limit=${query?.limit}`);
  if (query?.name) qpm.push(`name=${query?.name}`);
  if (query?.status) qpm.push(`status=${query?.status}`);
  if (query?.category) qpm.push(`category=${query?.category}`);

  let qpmString = '';
  if (qpm?.length > 0) qpmString = '?' + qpm.join('&');

  const res = await AspApi.get(
    `/api/v1/svc/whatsapp/template_utils/whatsapp_template_list${qpmString}`,
  );
  return res;
};

export const templateDiscard = async (id, payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/whatsapp/whatsapp_templates/${id}/discard_edit`,
    payLoad,
  );
  return res;
};
// export const UpdateTemplate = async (payLoad) => {
//   const res = await AspApi.patch(
//     `/api/v1/svc/whatsapp/whatsapp_templates/${id}`,
//     payLoad
//   );
//   return res;
// };

export const checkTemplateExits = async (query) => {
  let qpm = [];
  if (query.brandId) qpm.push(`brand_id=${query.brandId}`);
  if (query.name) qpm.push(`name=${query.name}`);
  let qpmString = '';
  if (qpm?.length > 0) qpmString = `?${qpm.join('&')}`;

  if (query?.name?.length > 0) {
    const res = await AspApi.get(
      `/api/v1/svc/whatsapp/template_utils/check_template_name${qpmString}`,
    );
    return res;
  }

  return null;
};

export const deleteTemplate = async (id, brandId) => {
  const res = await AspApi.delete(
    `/api/v1/svc/whatsapp/whatsapp_templates/${id}?brand_id=${brandId}`,
  );
  return res;
};

export const templateSyncApi = async (brandId) => {
  const res = await AspApi.post(
    `/api/v1/svc/whatsapp/template_utils/template_sync?brand_id=${brandId}`,
  );
  return res;
};

export const synctSingleTemplate = async (brandId, templateId) => {
  const res = await AspApi.put(
    `/api/v1/svc/whatsapp/template_utils/single_template_sync?brand_id=${brandId}&meta_template_id=${templateId}`,
  );
  return res;
};

export const templateMetrix = async (brandId) => {
  const res = await AspApi.get(
    `api/v1/svc/whatsapp/template_utils/template_overview?brand_id=${brandId}`,
  );
  return res;
};

export const createCarouselStep1 = async (payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/whatsapp/carousel_templates`,
    payLoad,
  );
  return res;
};

export const carouselAddCard = async (id, payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/whatsapp/carousel_templates/${id}/template_cards`,
    payLoad,
  );
  return res;
};

export const carouselSaveDraft = async (id, payLoad) => {
  const res = await AspApi.put(
    `/api/v1/svc/whatsapp/carousel_templates/${id}`,
    payLoad,
  );
  return res;
};

export const carouselCardUpdate = async (id, cardId, payLoad) => {
  const res = await AspApi.put(
    `/api/v1/svc/whatsapp/carousel_templates/${id}/template_cards/${cardId}`,
    payLoad,
  );

  return res;
};

export const carouselDelete = async (id, payload) => {
  const res = await AspApi.delete(
    `/api/v1/svc/whatsapp/carousel_templates/${id}`,
    {
      data: payload,
    },
  );
  return res;
};

export const carouselCardDelete = async (id, cardId, payLoad) => {
  const res = await AspApi.delete(
    `/api/v1/svc/whatsapp/carousel_templates/${id}/template_cards/${cardId}`,
    {
      data: payLoad,
    },
  );
  return res;
};

export const carouselCardDrag = async (id, payLoad) => {
  const res = await AspApi.put(
    `/api/v1/svc/whatsapp/carousel_templates/${id}/update_card_order`,
    payLoad,
  );
  return res;
};

export const carouselApprovedEdit = async (id, payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/whatsapp/carousel_templates/${id}/initiate_edit`,
    payLoad,
  );
  return res;
};

// End point should be changed for all templates using this get api....

export const carouselApprovedGet = async (id, brandId) => {
  const res = await AspApi.get(
    `/api/v1/svc/whatsapp/carousel_templates/${id}?brand_id=${brandId}`,
  );
  return res;
};

export const carouselDiscard = async (id, payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/whatsapp/carousel_templates/${id}/discard_edit`,
    payLoad,
  );
  return res;
};

export const carouselDuplicate = async (id, payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/whatsapp/carousel_templates/${id}/duplicate_template`,
    payLoad,
  );
  return res;
};

export const chatGpt = async (payLoad) => {
  try {
    const res = await OpenAiApi.post('/chat/completions', payLoad);
    return res.data;
  } catch (error) {
    console.error('OpenAI API Error:', error.response?.data || error);
    throw error;
  }
};

export const uploadFileToMeta = async ({ brandId, cloudUrl }, payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/whatsapp/template_utils/meta_asset_handler?brand_id=${brandId}&gainwix_cloud_url=${cloudUrl}`,
    payLoad,
  );
  return res.data;
};

// Flows
export const flowsList = async (brandId, query) => {
  let qpm = [];

  if (brandId) qpm.push(`brand_id=${brandId}`);
  if (query?.page) qpm.push(`page=${query?.page}`);
  if (query?.limit) qpm.push(`limit=${query?.limit}`);
  if (query?.search) qpm.push(`search=${query?.search}`);
  if (query?.status) qpm.push(`status=${query?.status}`);

  let qpmString = '';
  if (qpm?.length > 0) qpmString = `?${qpm.join('&')}`;

  const res = await AspApi.get(`/api/v1/svc/whatsapp/flows${qpmString}`);
  return res;
};

export const flowsGet = async (id, brandId, flowJson = false) => {
  const res = await AspApi.get(
    `/api/v1/svc/whatsapp/flows/${id}?brand_id=${brandId}&flow_json=${flowJson}`,
  );
  return res;
};

export const flowsSync = async (brandId) => {
  const res = await AspApi.post(
    `/api/v1/svc/whatsapp/flows/sync?brand_id=${brandId}`,
  );
  return res;
};

export const createFlow = async (payLoad) => {
  const res = await AspApi.post(`/api/v1/svc/whatsapp/flows`, payLoad);
  return res;
};

export const updateFlow = async (id, payLoad) => {
  const res = await AspApi.put(`/api/v1/svc/whatsapp/flows/${id}`, payLoad);
  return res;
};

export const deleteFlow = async (id, brandId) => {
  const res = await AspApi.delete(
    `/api/v1/svc/whatsapp/flows/${id}?brand_id=${brandId}`,
  );
  return res;
};

export const publishFlow = async (id, payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/whatsapp/flows/${id}/publish`,
    payLoad,
  );
  return res;
};

export const DeprecateFlow = async (id, brandId) => {
  const res = await AspApi.post(
    `/api/v1/svc/whatsapp/flows/${id}/deprecate?brand_id=${brandId}`,
  );
  return res;
};

export const flowsAssets = async (id, brandId, payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/whatsapp/flows/${id}/assets?brand_id=${brandId}`,
    payLoad,
  );
  return res;
};

export const flowsInsights = async (id, brandId, query) => {
  let qpm = [];

  if (brandId) qpm.push(`brand_id=${brandId}`);
  if (query?.page) qpm.push(`page=${query?.page}`);
  if (query?.limit) qpm.push(`limit=${query?.limit}`);
  if (query?.search) qpm.push(`search=${encodeURIComponent(query?.search)}`);
  else if (query?.name) qpm.push(`search=${encodeURIComponent(query?.name)}`);
  if (query?.status) qpm.push(`status=${encodeURIComponent(query?.status)}`);
  if (query?.broadcast_id)
    qpm.push(`broadcast_id=${encodeURIComponent(query?.broadcast_id)}`);
  if (query?.broadcastId)
    qpm.push(`broadcast_id=${encodeURIComponent(query?.broadcastId)}`);
  if (query?.campaign_sequence_id)
    qpm.push(
      `campaign_sequence_id=${encodeURIComponent(query?.campaign_sequence_id)}`,
    );
  if (query?.campaignSequenceId)
    qpm.push(
      `campaign_sequence_id=${encodeURIComponent(query?.campaignSequenceId)}`,
    );
  if (query?.start_date)
    qpm.push(`start_date=${encodeURIComponent(query?.start_date)}`);
  if (query?.end_date)
    qpm.push(`end_date=${encodeURIComponent(query?.end_date)}`);
  if (query?.category)
    qpm.push(`category=${encodeURIComponent(query?.category)}`);
  if (query?.hide_duplicates)
    qpm.push(`hide_duplicates=${query?.hide_duplicates}`);

  let qpmString = '';
  if (qpm?.length > 0) qpmString = `?${qpm.join('&')}`;

  const res = await AspApi.get(
    `/api/v1/svc/whatsapp/flows/${id}/insights${qpmString}`,
  );
  return res;
};

export const flowsInsightSources = async (id, brandId) => {
  const qpm = [];
  if (brandId) qpm.push(`brand_id=${brandId}`);
  const qpmString = qpm.length ? `?${qpm.join('&')}` : '';

  const res = await AspApi.get(
    `/api/v1/svc/whatsapp/flows/${id}/insight_sources${qpmString}`,
  );
  return res;
};

// Payment Configuration APIs
export const getPaymentConfigurations = async (brandId) => {
  const res = await AspApi.get(
    `/api/v1/svc/transaction/payment_configuration?brand_id=${brandId}`,
  );
  return res;
};

export const setDefaultPaymentConfiguration = async (id, brandId) => {
  const res = await AspApi.patch(
    `/api/v1/svc/transaction/payment_configuration/${id}/set_default?brand_id=${brandId}`,
  );
  return res;
};

export const deletePaymentConfiguration = async (id, brand_id) => {
  const res = await AspApi.delete(
    `/api/v1/svc/transaction/payment_configuration/${id}?brand_id=${brand_id}`,
  );
  return res;
};

export const syncPaymentConfigurations = async (brand_id) => {
  const res = await AspApi.put(
    `/api/v1/svc/transaction/payment_configuration/sync?brand_id=${brand_id}`,
  );
  return res;
};
